// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__7boNW","body":"Carousel_body__QEoST"};